<template>
<vs-row vs-type="flex">
    <vs-col vs-type="flex" vs-justify="" vs-align="center" vs-w="12">
       <div>
        <feather-icon v-if="activeUserInfo.role == 'doctor'" icon="EyeIcon" svgClasses="h-6 w-6 mr-5 hover:text-primary cursor-pointer" @click="viewRecord(params.data.id)" />
        <feather-icon v-if="!params.data.meta.paid" icon="CreditCardIcon" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="openModal(params.data)" />
        <feather-icon v-if="params.data.meta.html" icon="FileTextIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="openFact(params.data.meta.html)" />
      </div> 
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'CellRendererActions',
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    openFact(fact) {
      var win = window.open("", "_blank");
      win.document.body.innerHTML = fact
    },
    openModal(data) {
      this.params.showPaymentModal(data);
    },
    viewRecord(id) {
       this.$router.push(`/consultations/newConsultation/?consultationId=${id}`).catch(() => {})
    },
    editRecord () {
      this.$router.push(`/patients/patient/view/${268}`).catch(() => {})

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
